/*
 * @Author: changcheng
 * @LastEditTime: 2025-02-18 16:51:43
 */
import React from "react";
import { ExamGroup } from "./topicExamDoubleButton";
import { post } from "../../../../common/fetch";
import { Space, Pagination } from "antd";
import { VideoCameraTwoTone } from "@ant-design/icons";
// 课程列表项接口定义
interface CourseListProps {
  courseName: string;            // 课程名称
  courseWatchTimeText: string;   // 课程观看时长文本
  courseType: string;            // 课程类型
  progress: string;              // 学习进度
  hasQuestionnaireFlag: number;  // 是否有问卷标识
  hasExamFlag: number;           // 是否有考试标识
  courseOrder: number;           // 课程顺序
  examStatus: number;            // 考试状态
  projectId: number;             // 项目ID
  courseId: number;              // 课程ID
  courseLock: boolean;           // 课程是否锁定
  courseDurationText: string;    // 课程时长文本
  userPaperScoreId: number;      // 用户试卷得分ID
  courseExamShowFlag: number;    // 课程考试显示标识
  sectionList: Array<{           // 章节列表
    id: number;                  // 章节ID
  }>;
  userEvaluateFlag: number;      // 用户评价标识
  evaluateSubmitStatus?: 1 | 2;  // 测评提交状态
  showEvaluateCountFlag: number  // 显示评价数量标识
}

// 课程状态接口定义
interface CourseStateProps {
  courseList: CourseListProps[]; // 课程列表
  page: number;                  // 当前页码
  totalPage: number;             // 总页数
  pageSize: number;              // 每页显示数量
  totalResultSize: number;       // 总结果数量
}

// 组件属性类型定义
type propsType = {
  projectId: string;             // 项目ID
  topicId: string;              // 主题ID
  projectInfo: any;             // 项目信息
};
const trainStatus = new Map([
  [0, "未通过"],
  [1, "未通过"],
  [2, "已通过"],
  [4, "未通过"],
  [7, "未通过"],
]);

export class TopicCourseDoubleCourse extends React.Component<
  propsType,
  CourseStateProps
> {
  state = {
    courseList: [],
    page: 1,
    totalPage: 1,
    pageSize: 15,
    totalResultSize: 0,
  };
  // 问卷
  getProjectStarQuestionnaireUrl = async (rowData: CourseListProps) => {
    post(
      `/shop/questionnaire/getProjectTopicCourseStarQuestionnaireUrl`,
      rowData.projectId,
      true
    ).then((res: any) => {
      const { questionnaireUrl } = res.data;
      window.location.href = questionnaireUrl;
    });
  };
  private RenderCourseItem = (rowData: CourseListProps) => {
    return (
      <div className="topicCourseList">
        <p>{rowData.courseName}</p>
        <p>
          {rowData.courseWatchTimeText}·已学习{rowData.progress}
        </p>
        <p className="button_group">
          <ExamGroup
            Id={rowData.projectId}
            courseExamInfo={rowData as any}
            topicId={this.props.topicId}
            projectInfo={this.props.projectInfo}
          />
        </p>
      </div>
    );
  };
  private getMyCourseList = async (currentPage: number) => {
    const { projectId, topicId } = this.props;
    post(
      `/shop/front/project/topic/course/list`,
      {
        page: {
          currentPage: currentPage,
          pageSize: this.state.pageSize,
        },
        projectId,
        topicId,
      },
      true
    ).then((res: any) => {
      const { courseList, page } = res.data;
      const { totalResultSize } = page;
      this.setState({
        page: currentPage,
        courseList: courseList,
        totalResultSize,
      });
    });
  };
  public componentWillMount() {
    this.getMyCourseList(1);
  }
  render() {
    return (
      <>
        <div style={{ flex: 1 }}>
          {this.state.courseList.map((item: CourseListProps, index: number) => (
            <div
              className={
                item.courseLock
                  ? "topicCourseList_mask topicCourseList"
                  : "topicCourseList"
              }
              key={index}
            >
              <h5 style={{ display: "flex", alignItems: "center" }}>
                <VideoCameraTwoTone
                  twoToneColor={item.courseType === "course" ? "" : "red"}
                />
                &emsp;
                <span style={{ color: "#1890ff" }}>{item.courseOrder}</span>
                &emsp;{item.courseName}
              </h5>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Space>
                  {item.courseDurationText !== "00:00:00" && (
                    <span>课程时长：{item.courseDurationText}</span>
                  )}
                  {Number(item.progress) > 0 && (
                    <span>学习进度：{item.progress}%</span>
                  )}
                  {this.props.projectInfo.showCourseExamStatusFlag === 1 &&
                    item.courseExamShowFlag === 1 &&
                    item.hasExamFlag === 1 &&
                    item.courseType === "course" && (
                      <span>
                        &emsp;练习状态:
                        {trainStatus.get(item.examStatus)}
                      </span>
                    )}
                </Space>
                <p className="button_group">
                  <ExamGroup
                    Id={item.projectId}
                    courseExamInfo={item as any}
                    topicId={this.props.topicId}
                    projectInfo={this.props.projectInfo}
                  />
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="pagination-box">
          <h6>共{this.state.totalResultSize}门课程</h6>
          <Pagination
            total={this.state.totalResultSize}
            current={this.state.page}
            defaultPageSize={this.state.pageSize}
            showSizeChanger={false}
            onChange={(page) => {
              this.getMyCourseList(page);
              this.setState({
                page,
              });
            }}
          ></Pagination>
        </div>
      </>
    );
  }
}
